// extracted by mini-css-extract-plugin
module.exports = {"waveform":"Waveform_waveform__32nEt"};